import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the withdrawal request table view.
 * @extends JetView
 */
export default class tableWithdrawalRequestView extends JetView {
    /**
     * Configures the view layout and data table.
     * @returns {Object} Configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const cur_user = this.getParam('user', true); // Get current user parameter

        return {
            view: 'datatable', // Data table view
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            id: 'bankTable', // ID for the data table
            columns: [
                // Column definitions for the data table
                { id: 'Id', header: 'Id', width: 100, sort: 'int' }, // ID column
                { id: 'Bank', header: 'Banco', width: 250, sort: 'int' }, // Bank name column
                {
                    id: 'BankAccountNumber',
                    header: 'Número Cuenta Bancaria',
                    width: 250,
                    sort: 'int',
                }, // Bank account number column
                {
                    id: 'BankCodeInterbank',
                    header: 'Código Interbancario',
                    width: 250,
                    sort: 'int',
                }, // Interbank code column
                {
                    id: 'BankType',
                    header: 'Tipo Cuenta',
                    options: [
                        // Options for bank type
                        { id: '1', value: 'Ahorros' },
                        { id: '2', value: 'Corriente' },
                        { id: 'EVP', value: _('EVP') },
                        { id: 'CPF', value: _('CPF') },
                        { id: 'PHONE', value: _('PHONE') },
                        { id: 'EMAIL', value: _('EMAIL') },
                    ],
                    width: 150,
                    sort: 'int',
                }, // Bank type column
                {
                    id: 'State',
                    header: 'Estado',
                    editor: 'combo', // Combo editor for state
                    options: [
                        // Options for state
                        { id: 'A', value: 'Activo' },
                        { id: 'I', value: 'Inactivo' },
                    ],
                    width: 150,
                    sort: 'int',
                }, // State column
            ],
            editable: true, // Enable editing of the data table
            math: true, // Enable mathematical operations
            loadahead: devConfig.getDefaultDataFetch(), // Data fetch configuration
            pager: 'pagerA', // Pager ID for pagination
            // API URL for fetching data
            url: devConfig.geturlApi() + 'es/Client/GetClientBankAccounts?PlayerId=' + cur_user + '&',
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The data table instance.
     */
    init(grid) {
        const cur_user = this.getParam('user', true); // Get current user parameter
        var popup = webix.ui({
            // Create a popup window for editing
            view: 'window',
            id: 'editwin',
            head: 'Edit.. ',
            position: 'center',
            modal: true,
            body: {
                view: 'form', // Form inside the popup
                id: 'editform',
                elements: [
                    // Form elements
                    {
                        view: 'text',
                        label: 'Banco',
                        name: 'Bank',
                        readonly: true, // Read-only field
                        disabled: true, // Disabled field
                    },
                    {
                        view: 'text',
                        label: 'Número Cuenta Bancaria',
                        name: 'BankAccountNumber',
                        readonly: true, // Read-only field
                        disabled: true, // Disabled field
                    },
                    {
                        view: 'text',
                        label: 'Codigo Interbancario',
                        name: 'BankCodeInterbank',
                        readonly: true, // Read-only field
                        disabled: true, // Disabled field
                    },
                    {
                        view: 'combo',
                        label: 'Estado',
                        name: 'State',
                        options: [
                            // Options for state
                            { id: 'A', value: 'Activo' },
                            { id: 'I', value: 'Inactivo' },
                        ],
                    },
                    {
                        cols: [
                            // Button layout
                            {
                                view: 'button',
                                value: 'Cancelar', // Cancel button
                                click: function () {
                                    this.getTopParentView().hide(); // Hide popup on cancel
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                value: 'Guardar', // Save button
                                click: function ($e) {
                                    var values = $$('editform').getValues(); // Get form values
                                    webix
                                        .ajax() // AJAX request to save data
                                        .headers({
                                            'Content-type': 'application/json',
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'Client/SaveClientBankAccount',
                                            '{"Id":' + values.Id + ',"State":"' + values.State + '"}',
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message('Error! '); // Error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(
                                                        'Cell value was changed', // Success message
                                                    );
                                                },
                                            },
                                        );
                                    this.getTopParentView().hide(); // Hide popup after save
                                },
                            },
                        ],
                    },
                ],
            },
        });
        var url = grid.data.url; // Store the grid URL

        // Event handler for filtering bank account reports
        this.on(this.app, 'bankAccountReport:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range
                        var date = object[i][1].split(' - ');
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Append other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'MaxCreatedLocal=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Append start date to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'MinCreatedLocal=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Append end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&PlayerId=' + cur_user; // Append current user to query
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data
        });

        // Event handler for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event handler for before edit start
        grid.attachEvent('onBeforeEditStart', function (id) {
            var item = this.getItem(id); // Get item being edited
            console.log(item);
            if (id.column == 'State') {
                // Check if editing the state column
                var options = this.getColumnConfig('Action').collection; // Get action options
                if (item.State == 'A') {
                    options.remove('A'); // Remove 'Active' option
                } else if (item.State == 'I') {
                    options.remove('I'); // Remove 'Inactive' option
                } else {
                    return false; // Prevent editing if state is invalid
                }
                console.log(id);
            }
        });

        // Event handler for after edit stop
        grid.attachEvent('onAfterEditStop', function (state, editor, ignoreUpdate) {
            console.log(state);
            var item = this.getItem(editor.row); // Get edited item
            console.log(item);
            if (state.value != state.old) {
                // Check if value has changed
                if (state.value == 'A') {
                    // If set to 'Active'
                    webix
                        .ajax() // AJAX request to allow withdrawal requests
                        .headers({
                            'Content-type': 'application/json',
                        })
                        .post(devConfig.geturlApi() + 'Client/AllowWithdrawalRequests', '{ "Id":' + item.Id + '}', {
                            error: function (text, data, XmlHttpRequest) {
                                webix.message('Error! '); // Error message
                            },
                            success: function (text, data, XmlHttpRequest) {
                                item.State = 'P'; // Update item state to 'Pending'
                                webix.message('Cell value was changed'); // Success message
                            },
                        });
                }
                if (state.value == 'P') {
                    // If set to 'Pending'
                    webix
                        .ajax() // AJAX request to pay withdrawal requests
                        .headers({
                            'Content-type': 'application/json',
                        })
                        .post(devConfig.geturlApi() + 'Client/PayWithdrawalRequests', '{ "Id":' + item.Id + '}', {
                            error: function (text, data, XmlHttpRequest) {
                                webix.message('Error! '); // Error message
                            },
                            success: function (text, data, XmlHttpRequest) {
                                item.State = 'I'; // Update item state to 'Inactive'
                                webix.message('Cell value was changed'); // Success message
                            },
                        });
                }
                if (state.value == 'E') {
                    // If set to 'Cancelled'
                    webix
                        .ajax() // AJAX request to cancel client requests
                        .headers({
                            'Content-type': 'application/json',
                        })
                        .post(devConfig.geturlApi() + 'Client/CancelClientRequests', '{ "Id":' + item.Id + '}', {
                            error: function (text, data, XmlHttpRequest) {
                                webix.message('Error! '); // Error message
                            },
                            success: function (text, data, XmlHttpRequest) {
                                item.State = 'E'; // Update item state to 'Cancelled'
                                webix.message('Cell value was changed'); // Success message
                            },
                        });
                }
            }
        });

        // Event handler for item double click
        grid.attachEvent('onItemDblClick', function (id, e, node) {
            var item = this.getItem(id); // Get double-clicked item
            popup.show(); // Show the edit popup
        });

        // Event handler for player selection
        this.on(this.app, 'player:select', (id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + id, // Load data for selected player
            );
        });
        $$('editform').bind($$('bankTable')); // Bind form to the data table
    }
}

// FILE DOCUMENTED
